import { KeyboardEvent } from "react";

/**
 * Returns an `onKeyDown` handler that makes Enter consistent across form fields:
 *
 * - Prevents Enter from implicitly submitting the surrounding `<form>`.
 * - Triggers validation (via the supplied `onValidate`, typically `field.onBlur`)
 *   while keeping the caret/focus in the field — matching "validate on Enter even
 *   when no blur is fired".
 *
 */
export const createEnterValidateHandler =
  (onValidate?: (e: KeyboardEvent) => void) =>
  (e: KeyboardEvent): void => {
    if (e.key !== "Enter") return;
    if (e.nativeEvent.isComposing || (e.nativeEvent as unknown as { keyCode?: number }).keyCode === 229) return;
    if (e.defaultPrevented) return;
    if ((e.target as HTMLElement)?.tagName === "TEXTAREA") return;
    e.preventDefault();
    onValidate?.(e);
  };
